// getRandomValues is also available on the IP-based HTTP TEST console.
// randomUUID requires HTTPS (or localhost) in browsers.
export const newRequestKey = () => Array.from(crypto.getRandomValues(new Uint8Array(16)), byte => byte.toString(16).padStart(2, '0')).join('');
